import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  id: string;
};

export async function getOrderApi({ id }: Data) {
  return makeRequest(Service.getOrder(id, await identify()));
}
